import React from "react";
import { Check } from "react-feather";
import {
  HiddenState,
  StepDetail,
  StepItem,
  StepLabel,
  StepLine,
  StepMarker,
  StepText,
  StepperList,
} from "./Stepper.styles";
import type { StepperProps, StepperStepState } from "./Stepper.types";

const DEFAULT_STATE_LABELS: Record<StepperStepState, string> = {
  done: "done",
  current: "current step",
  todo: "not started",
};

/** Numbered steps in a row: a check once done, a filled number now, an outlined one ahead. */
export const Stepper: React.FC<StepperProps> = ({
  steps,
  currentId,
  ariaLabel,
  stateLabels = DEFAULT_STATE_LABELS,
  className,
}) => {
  const currentIndex = currentId === null ? steps.length : Math.max(0, steps.findIndex((step) => step.id === currentId));
  return (
    <StepperList aria-label={ariaLabel} className={className}>
      {steps.map((step, index) => {
        const state: StepperStepState = index < currentIndex ? "done" : index === currentIndex ? "current" : "todo";
        const last = index === steps.length - 1;
        return (
          <StepItem key={step.id} $last={last} aria-current={state === "current" ? "step" : undefined}>
            <StepMarker $state={state} aria-hidden="true">
              {state === "done" ? <Check /> : index + 1}
            </StepMarker>
            <StepText>
              <StepLabel $state={state}>
                {step.label}
                <HiddenState>{`, ${stateLabels[state]}`}</HiddenState>
              </StepLabel>
              {step.detail ? <StepDetail>{step.detail}</StepDetail> : null}
            </StepText>
            {last ? null : <StepLine aria-hidden="true" />}
          </StepItem>
        );
      })}
    </StepperList>
  );
};

export default Stepper;
